
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const ValorisationHero = () => {
  return (
    <section className="bg-gradient-to-br from-fabre-green via-fabre-teal to-fabre-darkgreen text-white py-12 md:py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl text-center md:text-left">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-4 md:mb-6 leading-tight">
            Valorisation des Déchets
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl opacity-90 mb-6 md:mb-8 leading-relaxed max-w-3xl">
            Transformons vos déchets en ressources avec nos solutions de valorisation innovantes et durables
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Button asChild size="lg" className="bg-white text-fabre-green hover:bg-gray-100 w-full sm:w-auto">
              <Link to="/contact">Demander un devis</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-fabre-green w-full sm:w-auto">
              <Link to="/sites">Nos sites</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValorisationHero;
